import { officePages } from "@/router/office";
export const API_URL = process.env.VUE_APP_API_URL;
export const FILE_URL = process.env.VUE_APP_FILE_URL;
export const FILE_URL_OFFICE = process.env.VUE_APP_FILE_URL_OFFICE;
export const MAIN_SYSTEM_URL = process.env.VUE_APP_MAIN_SYSTEM_URL;
export const SIGN_API_URL = process.env.VUE_APP_SIGN_API_URL;

export const SBS_API_URL = process.env.VUE_APP_SBS_API_URL;
export const SBS_FILE_URL = process.env.VUE_APP_SBS_FILE_URL;

export const NEXORA_URL = process.env.VUE_APP_NEXORA_URL || "https://nexora.smartremont.kz";

// "true" — у грейда 8 площади и замеры можно вводить руками, пока проектировщики
// переходят на Revit-плагин. Нет или любое другое значение — только из Revit.
// Значение вшивается при сборке.
export const GRADE8_MANUAL_INPUT = process.env.VUE_APP_GRADE8_MANUAL_INPUT === "true";

// "true" — сборка для тестового стенда: плашка «Тестовая система» и «[ТЕСТ]» в заголовке вкладки.
// Нет или любое другое значение — боевая система, плашки нет. Значение вшивается при сборке.
export const TEST_SYSTEM = process.env.VUE_APP_TEST_SYSTEM === "true";

export const SYSTEMS = {
  sr: { API_URL, FILE_URL, FILE_URL_OFFICE, MAIN_SYSTEM_URL, SIGN_API_URL },
  sbs: {
    API_URL: SBS_API_URL,
    FILE_URL: SBS_FILE_URL,
    FILE_URL_OFFICE: SBS_FILE_URL,
    MAIN_SYSTEM_URL: SBS_FILE_URL,
    SIGN_API_URL,
  },
};

export const PAGES_HEADS = {
  requests: "requests",
  remont: "remont",
  loginUrl: "login-url",
  installmentRefunds: "installment-refunds",
};

export const PAGES = {
  main: "/",
  login: "/login",
  financePayments: "/finance-payments",
  // menu_action в меню — installmentRefunds
  installmentRefunds: `/${PAGES_HEADS.installmentRefunds}`,
  creditProgramSettings: "/credit-program-settings",
  marginConfigSettings: "/margin-config-settings",
  warrantyRequests: "/warranty-requests",
  contragentAvrQueue: "/contragent-avr-queue",
  providerRequests: "/provider-requests",
  providerRequestAdditionDecisions: "/provider-requests/addition-decisions",
  shippingPlan: "/shipping-plan",
  balances: "/balances",
  materials: "/materials-list",
  materialConstructorList: "/material-constructor-list",
  materialBaseOperations: "/material-base-operations",
  promoMaterials: "/promo-materials",
  materialProviderList: "/material-provider-list",
  materialProvPriceChanges: "/mp-buffer-price-list",
  forgetPassword: "/forget-password",
  payments: "/payments",
  compareDataOneC: "/compare-data-one-c",
  timelineGrade: "/timeline-grade",
  timelineGradeSync: "/timeline-grade-sync",
  reportGenerator: "/report-generator",
  timelineRemont: "/timeline-client-requests",
  changeMaterialsRequests: "/change-materials-requests/:type",
  changeMaterialsRequestsAvail: "/change-materials-requests/AVAILABILITY",
  changeMaterialsRequestsPrice: "/change-materials-requests/PRICE",
  request: `/${PAGES_HEADS.requests}/:client_request_id`,
  remontPage: `/${PAGES_HEADS.remont}/:remont_id`,
  quickSearch: "/quick-search",
  kanban: "/kanban",
  kanbanBoard: "/kanban/board",
  kanbanBoardSprav: "/kanban/board-sprav",
  itSupportInbox: "/it-support/inbox",
  itSupportSettings: "/it-support/settings",
  notificationsInbox: "/notifications",
  realization: "/realization",
  agreementsJournal: "/contract-journal",
  executiveReports: "/executive-reports",
  completedStageReport: "/reports/completed-stage",
  projectReviewReport: "/reports/project-review",
  remontSlaReport: "/reports/remont-sla",
  designerPayReport: "/reports/designer-pay",
  clientDebtRemontReport: "/reports/client-debt-remont",
  clientRequestDebtReport: "/reports/client-request-debt",
  clientCashflowReport: "/reports/client-cashflow",
  reportTech: "/reports/tech",
  reportProviderRequestService: "/reports/provider-request-service",
  handbook: "/handbook/:type",
  handbookWorksets: "/handbook/worksets",
  handbookNoticeTemplates: "/handbook/notice-templates",
  handbookProviders: "/handbook/providers",
  handbookProvidersAgreement: "/handbook/providers-agreement",
  handbookOrgFiles: "/handbook/documents",
  handbookServiceMasters: "/handbook/service-masters",
  handbookMobileApps: "/handbook/mobile-apps",
  handbookGradeActions: "/handbook/grade-actions",
  handbookStepActivities: "/handbook/step-activities",
  handbookTimelineSteps: "/handbook/timeline-steps",
  handbookTimelineStepConditions: "/handbook/timeline-step-conditions",
  handbookGradeTimelineSteps: "/handbook/grade-timeline-steps",
  handbookContractors: "/handbook/handbook-contractors",
  handbookTechprojectDevelopers: "/handbook/techproject-developers",
  handbookContractorCompany: "/handbook/contractor-company",
  handbookCompanyLimit: "/handbook/company-limit",
  handbookMaterialTypes: "/handbook/material-types",
  handbookMaterialSets: "/handbook/material-sets",
  handbookMaterialSetEdit: "/handbook/material-sets/:id",
  handbookMaterialPaints: "/handbook/material-paints",
  handbookCleaning: "/handbook/cleaning",
  handbookRemontTermSettings: "/handbook/remont-term-settings",
  handbookDesignerPayTariff: "/handbook/designer-pay-tariff",
  handbookPresetKitDisplayRules: "/handbook/preset-kit-display-rules",
  renderStandard: "/renders/standard",
  renderPlan: "/renders/plan",
  renderUpload: "/renders/upload",
  handbookDduAreaDiff: "/handbook/ddu-area-diff",
  loginUrl: `/${PAGES_HEADS.loginUrl}/:token`,
  logging: "/logs",
  profile: "/profile",
  techprojectRequests: "/techproject-requests",
  roomBooking: "/room-booking",
  residentialSettings: "/residential-settings",
  remarketContractorInfo: "/remarket-cont-info",
  showrooms: "/showrooms",
  imageUrl: "/image-url",
  bufferParams: "/buffer-params",
  revitBufferParams: "/revit-buffer-params",
  revitData: "/revit-data",
  revitPresetMaterials: "/revit-preset-materials",
  revitPluginVersions: "/revit-plugin-versions",
  revitProjectTemplates: "/revit-project-templates",
  flatList: "/flat-list",
  frameTypes: "/frame-types",
  framesList: "/frames-list",
  shellEstimates: "/shell-estimates",
  shellRooms: "/shell-rooms",
  shellProjects: "/shell-projects",
  workSetCheckGroups: "/work-set-check-groups",
  workSetCheckGroupsLink: "/work-set-check-groups-link",
  floorParams: "/floor-params",
  cronJobs: "/cron_jobs",
  companyKeyStore: "/company-key-store",
  timelineZoneReport: "/timeline-zone-report",
  timelineZoneSettings: "/timeline-zone-settings",
  timelineFieldSettings: "/timeline-field-settings",
  timelineCompare: "/timeline-compare",
  timelineMonitoring: "/timeline-monitoring",
  timelineEventSettings: "/timeline-event-settings",
  timelineEventLog: "/timeline-event-log",
  // Этапы ГПР (новый режим)
  wgprOverview: "/wgpr",
  wgprRequests: "/wgpr/requests",
  wgprRemonts: "/wgpr/remonts",
  wgprRemont: "/wgpr/remont/:remont_id",
  wgprContractor: "/wgpr/contractor",
  wgprOkk: "/wgpr/okk",
  wgprPayments: "/wgpr/payments",
  wgprMaterials: "/wgpr/materials",
  wgprReports: "/wgpr/reports",
  wgprTemplates: "/wgpr/templates",
  wgprTemplate: "/wgpr/templates/:template_id",
  wgprPrices: "/wgpr/prices",
  wgprCheckLists: "/wgpr/check-lists",
  residentPresetList: "/resident-preset-list",
  planirovka: "/planirovka",
  planirovkaV2: "/planirovka-v2",
  presetKitList: "/preset-kit-list",
  estimateConstructorSurfaces: "/estimate-constructor/surfaces",
  contracts: "/contracts",
  sync1c: "/sync-1c",
  dduContractor: "/ddu-contractor",
  dduResidents: "/ddu_residents",
  handbookPresetKitDisplayRules: "/handbook/preset-kit-display-rules",
  cmsBanners: "/cms/banners",
  cmsSalePoints: "/cms/sale-points",
  cmsPresetKitInfo: "/cms/preset-kit-info",
  hunterDealLimits: "/crm/hunter-deal-limits",
  clientMessagesSent: "/client-messages/sent",
  clientMessagesProcessed: "/client-messages/processed",
};
// Страницы, перенесённые из старого Office: адреса — в src/router/office/<раздел>.js.
// Ключи, которые уже есть в PAGES, не перекрываем (свои страницы My Space главнее).
Object.entries(officePages).forEach(([key, path]) => {
  if (!(key in PAGES)) PAGES[key] = path;
});

export const LOCALSTORAGEFIELDS = {
  accessToken: "accessTokenOffice",
  refreshToken: "refreshTokenOffice",
  fingerToken: "fingerTokenOffice",
  menuDrawerOpen: "menuDrawerOpen",
  activeSystem: "activeSystem",
};

export const MODAL_NAMES = {
  CONFIRM: "ConfirmModal",
  TEXT_MODAL: "modal-text",
  ADD_FINANCE_PAYMENT: "AddFinancePayment",
  CreateAdditionalAgreement: "CreateAdditionalAgreement",
  CHANGE_PAYMENT_STATUS: "ChangePaymentStatus",
  CHANGE_MATERIAL_STATUS: "ChangeMaterialStatus",
  REMONT_TIMELINE_STEP: "RemontTimelineStep",
  GRADE_TIMELINE_STEP: "GradeTimelineStep",
  CHANGE_FINANCE_PAYMENT: "change-finance-payment",
  FINANCE_PAYMENT_DOCS: "FinancePaymentDocs",
  RECEIVE_KEYS_EDIT: "ReceiveKeysEdit",
  REMONT_PROJECT_EDIT: "RemontProjectEdit",
  CHECK_LIST_PHOTOS: "CheckListPhotos",
  Participants_Replacement_History: "ParticipantsReplacementHistory",
  Change_Remont_Responsible: "ChangeRemontResponsible",
  Change_Remont_Grade: "ChangeRemontGrade",
  AddTranche: "AddTranche",
  AddIncome: "AddIncome",
  AddCost: "AddCost",
  AddStage: "AddStage",
  AddRemontService: "AddRemontService",
  AddDoc: "AddDoc",
  ProjectReview: "ProjectReview",
  AddMobileAppVersion: "AddMobileAppVersion",
  AddRoom: "AddRoom",
  ExecutiveReportComments: "ExecutiveReportComments",
  ExecutiveReportDeadlineView: "ExecutiveReportDeadlineView",
  ExecutiveReportSetDeadline: "ExecutiveReportSetDeadline",
  ExecutiveReportEmployeeSet: "ExecutiveReportEmployeeSet",
  ExecutiveReportBulkAssignDesigner: "ExecutiveReportBulkAssignDesigner",
  ExecutiveReportNps: "ExecutiveReportNps",
  ExecutiveReportAnalyze: "ExecutiveReportAnalyze",
  ExecutiveReportWarrantyAccept: "ExecutiveReportWarrantyAccept",
  ExecutiveReportFlatList: "ExecutiveReportFlatList",
  ExecutiveReportOkk: "ExecutiveReportOkk",
  ApartmentOwnersHistory: "ApartmentOwnersHistory",
  ChangeWarrantyStatus: "ChangeWarrantyStatus",
  ChangeWarrantyEmployee: "ChangeWarrantyEmployee",
  ChangeDSSum: "ChangeDSSum",
  ChangeWarrantyRequest: "ChangeWarrantyRequest",
  WarrantyAct: "WarrantyAct",
  WarrantyRequestDocuments: "WarrantyRequestDocuments",
  AddAgreement: "AddAgreement",
  AddAvr: "AddAvr",
  AddGradeAction: "AddGradeAction",
  AddTimelineStep: "AddTimelineStep",
  AddStepCondition: "AddStepCondition",
  AddStepIncludeCond: "AddStepIncludeCond",
  AddGradeTimelineStep: "AddGradeTimelineStep",
  NestedGradeTimelineSteps: "NestedGradeTimelineSteps",
  AddStepActivity: "AddStepActivity",
  ChatGallery: "ChatGallery",
  Add_NOTICE_TEMPLATE: "AddNoticeTemplate",
  Add_HANDBOOK_DOCUMENT: "AddHandbookDocument",
  Add_HANDBOOK_PROVIDER: "AddHandbookProvider",
  Add_HANDBOOK_CONTRACTOR: "AddHandbookContractor",
  INSTALLMENT_REFUND: "InstallmentRefund",
  Add_HANDBOOK_TECHPROJECT_DEVELOPER: "AddHandbookTechprojectDeveloper",
  Add_HANDBOOK_CLEANING: "AddHandbookCleaning",
  ADD_PROVIDERS_AGREEMENT: "AddProvidersAgreement",
  UPDATE_BALANCES: "UpdateBalances",
  EditChatMessage: "EditChatMessage",
  PROVIDER_REQUEST_SERVICE_COMMENT: "ProviderRequestServiceComment",
  EDIT_HANDBOOK_WORKSET: "EditHandbookWorkset",
  EDIT_HANDBOOK_WORKSET_SPECIALITY: "EditHandbookWorksetSpeciality",
  ADD_HANDBOOK_CONTRACTOR_WORKSET: "AddHandbookContractorWorkset",
  ADD_WORKSET_PRICE: "AddWorksetPrice",
  ADD_HIDDEN_WORKSET: "AddHiddenWorkset",
  TEXT_CONSTRUCTOR_WORKS: "TextConstructorWorks",
  TEXT_CONSTRUCTOR_MATERIALS: "TextConstructorMaterials",
  TEXT_CONSTRUCTOR_INFO: "TextConstructorInfo",
  TEXT_CONSTRUCTOR_MATERIAL_PRICE_CHANGE: "TextConstructorMaterialPriceChange",
  PROVIDER_REQUESTS_PROVIDER_FORM: "ProviderRequestsProviderForm",
  PROVIDER_REQUESTS_CONTRACTOR_FORM: "ProviderRequestsContractorForm",
  PROVIDER_REQUESTS_SHIPPING_DATE_HISTORY:
    "ProviderRequestsShippingDateHistory",
  PROVIDER_REQUESTS_SHIPPING_DATE_CHANGE: "ProviderRequestsShippingDateChange",
  PROVIDER_REQUESTS_CONTRACTOR_APPROVE: "ProviderRequestsContractorApprove",
  PROVIDER_REQUESTS_QTY_DELIVERY_CHNG: "ProviderRequestsQtyDeliveryChange",
  PROVIDER_REQUESTS_ITEM_PAINT: "ProviderRequestsItemPaint",
  PROVIDER_REQUESTS_INVOICE_ITEM: "ProviderRequestsInvoiceItem",
  PROVIDER_REQUESTS_GENERATE_INVOICE: "ProviderRequestsGenerateInvoice",
  PROVIDER_REQUESTS_MULTIPLE_STATUS: "ProviderRequestsMultipleStatus",
  PROVIDER_REQUESTS_MULTIPLE_INVOICE: "ProviderRequestsMultipleInvoice",
  PROVIDER_REQUESTS_CHANGE_WAREHOUSE: "ProviderRequestsChangeWarehouse",
  PROVIDER_REQUESTS_SHIP_FROM_WAREHOUSE: "ProviderRequestsShipFromWarehouse",
  PROVIDER_REQUESTS_INVOICE_LIST: "ProviderRequestsInvoiceList",
  PROVIDER_REQUESTS_STATUS_HISTORY: "ProviderRequestsStatusHistory",
  PROVIDER_REQUESTS_REFUND_INVOICES: "ProviderRequestsRefundInvoices",
  PROVIDER_REQUESTS_REFUND_RELEASE: "ProviderRequestsRefundRelease",
  PROVIDER_REQUESTS_MATERIAL_SELECT: "ProviderRequestsMaterialSelect",
  PROVIDER_REQUEST_ADDITION_REJECT: "ProviderRequestAdditionReject",
  MATERIAL_LIST_SET_REQUIREMENT: "MaterialListSetRequirement",
  MATERIAL_LIST_ATTACH_AGREEMENT: "MaterialListAttachAgreement",
  MATERIAL_LIST_ADD_PRICE: "MaterialListAddPrice",
  MATERIALS_CONSTRUCTOR_UPD_IMAGES: "MaterialsConstructorUpdImages",
  MATERIALS_CONSTRUCTOR_UPD_KITCHEN_DESC: "MaterialsConstructorUpdKitchenDesc",
  MATERIALS_CONSTRUCTOR_UPD_ADDITIONAL_IMGS:
    "MaterialsConstructorUpdAdditionalImgs",
  MATERIALS_CONSTRUCTOR_UPD_PROP: "MaterialsConstructorUpdProp",
  MATERIALS_INFO: "MaterialsInfo",
  MATERIAL_GROUP_MEASURE: "MaterialGroupMeasure",
  ADD_PROMO_MATERIAL: "AddPromoMaterial",
  FLOOR_SCHEMA_OBJECT_INFO: "FloorSchemaObjectInfo",
  RESIDENTIAL_GROUPING: "ResidentialGrouping",
  ADD_CONTRACTOR_WORKS_PHOTO: "AddContractorWorksPhoto",
  ADD_CONTRACTOR_REVIEW: "AddContractorReview",
  AddFloorMap: "AddFloorMap",
  ADD_SHOWROOM_PHOTO: "AddShowroomPhoto",
  FLAT_COMMON_AREA_UPD: "FlatCommonAreaUpd",
  FLAT_CLONE: "FlatClone",
  FLOOR_MAP_ERRORS: "FloorMapErrors",
  FRAME_TYPE_PARAMS: "FrameTypeParams",
  UPD_FRAME_TYPE_PARAM: "UpdFrameTypeParam",
  FRAME_UPD: "FrameUpd",
  UPD_SHL_PROJECTS: "UpdShellProjects",
  UPD_SHL_PROJECT_PERFOMANCER: "UpdShellProjectPerfomancer",
  ADD_WORK_SET_CHECK_GROUPS: "AddWorkSetCheckGroups",
  ADD_WORK_SET_CHECK_GROUPS_LINK: "AddWorkSetCheckGroupsLink",
  COPY_PASTE_ENTRANCE_PROPERTIES: "CopyPasteEntranceProperties",
  CHANGE_PROJECT_MATERIALS: "ChangeProjectMaterials",
};

export const changeStatusesNames = {
  CANCELED: "CANCELED",
  ACCEPTED: "ACCEPTED",
  DENIED: "DENIED",
  PENDING: "PENDING",
};

export const timelineStepsCodes = {
  COMPLETED: "COMPLETED",
  NOT_STARTED: "NOT_STARTED",
  CURRENT: "CURRENT",
};
